import React from "react";
import { Link } from "react-router-dom";

const QueueNav = ({ selected }) => (
  <p>
    {selected !== "ended" && <Link to="/queue/ended">End Detected Queue</Link>}
    {selected === "ended" && <span>End Detected Queue</span>} &middot;{" "}
    {selected !== "new" && (
      <Link to="/queue/started">Start Detected Queue</Link>
    )}
    {selected === "new" && <span>Start Detected Queue</span>} &middot;{" "}
    {selected !== "qa" && <Link to="/queue/qa">Manual Screening Queue</Link>}
    {selected === "qa" && <span>Manual Screening Queue</span>} &middot;{" "}
    {selected !== "problem" && <Link to="/queue/problem">Problem Queue</Link>}
    {selected === "problem" && <span>Problem Queue</span>}
  </p>
);

export default QueueNav;
